import { hasCriterionGradingSettings } from 'utils/gradingInstructions';

const getRubricCriteria = (rubric) => (Array.isArray(rubric?.criteria) ? rubric.criteria : []);

const getInstructionEntries = (source) => {
    const criteria = source?.ai_grading_settings?.criteria;
    return criteria && typeof criteria === 'object' && !Array.isArray(criteria) ? criteria : {};
};

export const getMeaningfulSourceCriterionIds = (source) => {
    const rubricCriteria = getRubricCriteria(source?.rubric);
    const instructionEntries = getInstructionEntries(source);
    const rubricIds = new Set(rubricCriteria.map(({ id }) => `${id}`));
    const sourceIds = rubricCriteria
        .map(({ id }) => `${id}`)
        .filter((id) => hasCriterionGradingSettings(instructionEntries[id]));
    const orphanIds = Object.entries(instructionEntries)
        .filter(([id, instruction]) => !rubricIds.has(`${id}`) && hasCriterionGradingSettings(instruction))
        .map(([id]) => `${id}`);

    return [...sourceIds, ...orphanIds];
};

export const getGradingMappingAnalysis = ({ source, targetRubric, mapping = {}, importsRubric = false }) => {
    const sourceIds = getMeaningfulSourceCriterionIds(source);
    const sourceRubricIds = new Set(getRubricCriteria(source?.rubric).map(({ id }) => `${id}`));
    const targetIds = new Set(getRubricCriteria(targetRubric).map(({ id }) => `${id}`));
    const orphanSourceIds = sourceIds.filter((sourceId) => !sourceRubricIds.has(sourceId));
    const orphanSourceIdSet = new Set(orphanSourceIds);
    const unmappedSourceIds = sourceIds.filter((sourceId) => {
        if (importsRubric && !orphanSourceIdSet.has(sourceId)) return false;
        return !targetIds.has(`${mapping[sourceId]}`);
    });
    const unmappedSourceIdSet = new Set(unmappedSourceIds);
    const mappedSourceIds = sourceIds.filter((sourceId) => !unmappedSourceIdSet.has(sourceId));
    const unmappedOrphanSourceIds = unmappedSourceIds.filter((sourceId) => orphanSourceIdSet.has(sourceId));

    return {
        mappedCount: mappedSourceIds.length,
        unmappedCount: unmappedSourceIds.length,
        mappedSourceIds,
        unmappedSourceIds,
        orphanSourceIds,
        unmappedOrphanSourceIds,
    };
};
